import { Component } from '@angular/core';
import { DashboardService } from 'src/app/core/services/dashboard.service';
import { ToastService } from 'src/app/core/services/toast.service';

interface StatusMeta {
  key: string;
  label: string;
  icon: string;
  badgeClass: string;
}

@Component({
    selector: 'app-e-stamp-dashboard',
    templateUrl: './e-stamp-dashboard.component.html',
    styleUrl: './e-stamp-dashboard.component.scss',
    standalone: false
})
export class EStampDashboardComponent {
  loading = false;
  stampDashboardData: any = {};

  stampStatusList: StatusMeta[] = [
    { key: 'ORDER_CREATED', label: 'Order Created', icon: 'mdi-file-plus-outline', badgeClass: 'bg-secondary-subtle text-secondary' },
    { key: 'INVOICE_GENERATED', label: 'Invoice Generated', icon: 'mdi-file-document-outline', badgeClass: 'bg-info-subtle text-info' },
    { key: 'PAYMENT_SUBMITTED', label: 'Payment Submitted', icon: 'mdi-cash-multiple', badgeClass: 'bg-primary-subtle text-primary' },
    { key: 'PAYMENT_REJECTED', label: 'Payment Rejected', icon: 'mdi-cash-remove', badgeClass: 'bg-danger-subtle text-danger' },
    { key: 'ORDER_PROCESSING', label: 'Processing', icon: 'mdi-progress-clock', badgeClass: 'bg-warning-subtle text-warning' },
    { key: 'ORDER_FULFILLED', label: 'Fulfilled', icon: 'mdi-check-circle-outline', badgeClass: 'bg-success-subtle text-success' },
    { key: 'ORDER_REJECTED', label: 'Rejected', icon: 'mdi-close-circle-outline', badgeClass: 'bg-danger-subtle text-danger' },
  ];

  invoiceStatusList: StatusMeta[] = [
    { key: 'GENERATED', label: 'Generated', icon: 'mdi-file-document-outline', badgeClass: 'bg-info-subtle text-info' },
    { key: 'PAID', label: 'Paid', icon: 'mdi-check-circle-outline', badgeClass: 'bg-success-subtle text-success' },
    { key: 'CANCELLED', label: 'Cancelled', icon: 'mdi-close-circle-outline', badgeClass: 'bg-danger-subtle text-danger' },
  ];

  constructor(private dbs: DashboardService, private toastService: ToastService) { }

  ngOnInit() {
    this.getStampDashboard();
  }

  getStampDashboard() {
    this.loading = true;
    this.dbs.getStampDashboardData().subscribe((res: any) => {
      this.stampDashboardData = res.data || {};
      this.loading = false;
    }, (err) => {
      this.loading = false;
    })
  }

  statusBadgeClass(status: string): string {
    const meta = [...this.stampStatusList, ...this.invoiceStatusList].find(s => s.key === status);
    return meta ? meta.badgeClass : 'bg-secondary-subtle text-secondary';
  }

  statusLabel(status: string): string {
    const meta = [...this.stampStatusList, ...this.invoiceStatusList].find(s => s.key === status);
    return meta ? meta.label : status;
  }

}
